<template>
    <div class="text-center">
        <i v-if="meta.icon" :class="iconClass" :style="iconStyle" style="font-size: 27px"></i>
        <span v-else v-text="text"></span>
    </div>
</template>

<script>
    export default {
        props: ['value', 'meta'],

        computed: {
            text() {
                return this.value.value ? this.meta.texts.true : this.meta.texts.false
            },

            iconClass() {
                return this.value.value ? this.meta.iconClass.true : this.meta.iconClass.false;
            },

            iconStyle() {
                return {
                    color: this.value.value ? '#4dbd74' : '#f86c6b'
                }
            },
        }
    }
</script>
